import type { MenuBaseOn } from '../../stores/modules/settings/types';
import { useSettingsStore } from '../../stores';

/**
 * 获取角色信息
 */
export const getRoles = async (baseOn: MenuBaseOn) => {
  const { settings } = useSettingsStore();
  return settings.role.getRoles?.(baseOn);
};
